import React from 'react';
import { BREAKPOINTS_NUM } from 'constants/Global/Breakpoints.const';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { ProductCardListMobile } from './ProductCardListMobile';
import { ProductCardListDesktop } from './ProductCardListDesktop';
import { ProductCardListProps } from './types';

const isMobileQuery = `(max-width: ${BREAKPOINTS_NUM.tabletMini - 1}px)`;

export function ProductCardList(props: ProductCardListProps) {
  const isMobile = useMediaQuery(isMobileQuery);
  
  return isMobile 
    ? <ProductCardListMobile {...props} />
    : <ProductCardListDesktop {...props} />;
}
